import React from "react";
import _ from "i18n";

const TypeFormatFilter = ({ legendType, updateLegendType }) => {
  return (
    <div className={"event-registrant-type-container"}>
      <div
        className={"event-registrant-type-option " + (legendType === "TYPE" ? 'selected' : '')}
        onClick={() => updateLegendType('TYPE')}
      >
        {_('TYPE')}
        <div className='event-stats-progress-filter-wrapper'></div>
      </div>

      <div
        className={"event-registrant-type-option " + (legendType === "FORMAT" ? 'selected' : '')}
        onClick={() => updateLegendType('FORMAT')}
      >
        {_('FORMAT')}
        <div className='event-stats-progress-filter-wrapper'>
          <div className='event-stats-progress-filter-bar' />
        </div>
      </div>
    </div>
  );
};

export default TypeFormatFilter;



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/EventRegistrantLinechart/TypeFormatFilter.js